// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import './assets/element-variables.scss';

import App from './App.vue';
import router from './router'
import VueAnimateNumber from 'vue-animate-number'
import './assets/index.css'
import "babel-polyfill"
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'D4cxhpDLAmKTeI9tTCBSX730k3SbpmFn'
})
import 'animate.css'
Vue.use(VueAnimateNumber)

import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';
const swiper = new Swiper();

Vue.use(ElementUI);

import VueTouch from 'vue-touch'
Vue.use(VueTouch, {name: 'v-touch'})

import axios from 'axios'
Vue.prototype.$http = axios;
Vue.prototype.GetQueryString = function(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
},

Vue.config.productionTip = false

const Basrurl='http://47.111.17.123'
// const Basrurl='http://localhost:8082'

axios.defaults.baseURL = Basrurl;
Vue.prototype.baseURL = Basrurl;

// 遍历路由name 设置页面标题
router.beforeEach((to, from, next) => {

  if (to.name) {
    var local = localStorage.getItem('language')||'zh'
    document.title = local=='zh'?to.meta.title:to.meta.titleEn;
  }
  next()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  render: h => h(App),
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js